import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  tryToGetOrganizationInvites,
  tryToGetOrganizationInvitesLog
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Send invites to an organization
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSendOrganizationInvites = packet => {
  return {
    type: 'REQUEST_SEND_ORGANIZATION_INVITES',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSendOrganizationInvitesSuccess = data => ({
  type: 'RECEIVE_SEND_ORGANIZATION_INVITES_SUCCESS',
  data
})

export const receiveSendOrganizationInvitesFail = data => ({
  type: 'RECEIVE_SEND_ORGANIZATION_INVITES_FAIL',
  data
})

export const tryToSendOrganizationInvites = packet => (dispatch, getState) => {

  dispatch(requestSendOrganizationInvites(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/organizations/invites/' + packet.id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSendOrganizationInvitesSuccess(json));
      dispatch(tryToGetOrganizationInvites({id: packet.id}));
      dispatch(tryToGetOrganizationInvitesLog({id: packet.id}));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveSendOrganizationInvitesFail({errors:e, lastSubmit: packet}));
    })
}
